/**
 * @file PreviousChallengeCard — one archived competition in the Previous
 * Challenges grid. Season/Week come from the (small) index; Title, Theme,
 * Generated date and preview image are filled in by lazily fetching that week's
 * manifest. Play links to the archived play route.
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useEntryManifest } from '../hooks/data';
import { routes } from '../config/scrWeeklyConfig';
import { previewImageUrl } from '../services/manifestNormalizer';
import { formatDate, weekLabel } from '../utils/format';

/** @param {{ src: string, alt: string }} props */
function Preview({ src, alt }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return <div className="scrw-card__fallback" aria-hidden="true" />;
  }
  return (
    <img
      className="scrw-card__img"
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}

/** @param {{ entry: import('../models/archive').ArchiveIndexEntry }} props */
export function PreviousChallengeCard({ entry }) {
  const { data: competition, loading, error } = useEntryManifest(entry);
  const playTo = routes.play(entry.id);

  const title = competition ? competition.title : loading ? 'Loading…' : 'Untitled challenge';
  const theme = competition ? competition.theme : '';
  const generated = competition ? formatDate(competition.generatedAt) : null;
  const preview = competition ? previewImageUrl(competition) : '';

  return (
    <article className="scrw-card">
      <Link className="scrw-card__media" to={playTo} aria-label={`Play ${title}`}>
        <Preview src={preview} alt={`${title} preview`} />
      </Link>
      <div className="scrw-card__body">
        <p className="scrw-card__week">
          Season {entry.season} · {weekLabel(entry.week)}
        </p>
        <h3 className="scrw-card__title">
          <Link to={playTo}>{title}</Link>
        </h3>
        {theme ? <p className="scrw-card__theme">{theme}</p> : null}
        {/* {generated ? (
          <p className="scrw-card__generated">Generated {generated}</p>
        ) : null} */}
        {error ? (
          <p className="scrw-card__note">Details unavailable</p>
        ) : null}
        <div className="scrw-card__actions">
          <Link className="scrw-btn scrw-btn--primary scrw-btn--sm" to={playTo}>
            ▶ Play
          </Link>
        </div>
      </div>
    </article>
  );
}
